import { useEffect, useState } from 'react';
import { LinkSettings } from '@sharefiledev/sharing-pilet-sdk/api';
import { PermissionsHttp } from '../../../PermissionsHttp';

export const useLinkSettings = (consumerPluginName?: string) => {
	const [accountLevelLinkSettings, setAccountLevelLinkSettings] = useState<
		LinkSettings | undefined
	>(undefined);

	useEffect(() => {
		const fetchSettings = async () => {
			const settings = await PermissionsHttp.getLinkSettings(consumerPluginName);
			setAccountLevelLinkSettings(settings);
		};
		fetchSettings();
	}, [consumerPluginName]);

	return { accountLevelLinkSettings };
};
